module.exports = __webpack_public_path__ + "img/health-down.5451d697.png";